/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, Grid, Icon, LinearProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';


import { DamsServices, IDam, IInstrumento } from '../../services/api/dams/DamServices';
import { MarkerPoint, ToolsDamInformation, ButtonsDamInformation, ForwardedMapRender } from '../../components/custom';
import { VMenu } from '../../components/shared';
import { LayoutBase } from '../../layouts';

import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import TableForecast from '../../components/custom/TableForecast';

export const InformationDam: React.FC = () => {
    // eslint-disable-next-line
    const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#e8eaed'><path d='M80-240v-80q38 0 56.5-20t77.5-20q59 0 77.5 20t54.5 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20q38 0 55.5-20t76.5-20q59 0 77.5 20t56.5 20v80q-57 0-77.5-20T746-280q-36 0-54.5 20T614-240q-57 0-77.5-20T480-280q-38 0-56.5 20T346-240q-59 0-76.5-20T214-280q-38 0-56.5 20T80-240Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-440q-36 0-54.5 20T614-400q-57 0-77.5-20T480-440q-38 0-55.5 20T348-400q-59 0-78.5-20T214-440q-36 0-56.5 20T80-400Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-600q-36 0-54.5 20T614-560q-57 0-77.5-20T480-600q-38 0-55.5 20T348-560q-59 0-78.5-20T214-600q-36 0-56.5 20T80-560Z'/></svg>";

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const [data, setData] = useState<IDam>();

    const [center, setCenter] = useState<[number, number]>();
    const [damName, setDamName] = useState<string>('');
    const [instrumentos, setInstrumentos] = useState<IInstrumento[]>();
    const [showLabel, setShowLabel] = useState(true);
    const mapRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [markerPoints, setMarkerPoints] = useState<MarkerPoint[]>([]);
    const url = useParams();

    const vMenuRef = useRef<HTMLDivElement>(null);
    const [vMenuHeight, setVMenuHeight] = useState(0);

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const calculateVMenuHeight = () => {
            if (vMenuRef.current) {
                setVMenuHeight(vMenuRef.current.offsetHeight);
            }
        };

        calculateVMenuHeight();
        window.addEventListener('resize', calculateVMenuHeight);
        const observer = new MutationObserver(calculateVMenuHeight);
        if (vMenuRef.current) {
            observer.observe(vMenuRef.current, { childList: true, subtree: true, attributes: true });
        }
        return () => {
            window.removeEventListener('resize', calculateVMenuHeight);
            observer.disconnect();
        };
    }, []);

    const fetchData = () => {
        if (url) {
            if (url.id) {
                DamsServices.getById(url.id)
                    .then((response) => {
                        if (response instanceof Error) {
                            console.log(response.message);
                        } else {
                            if (response.latitude && response.longitude) {
                                setCenter([Number(response.latitude), Number(response.longitude)]);
                                setData(response);
                                setDamName(response.nome);
                            }
                            if (response.instrumentos) {
                                setInstrumentos(response.instrumentos);
                            }
                            setIsLoading(false);
                        }
                    });
            }
        }
    };

    function handleLabelChange(newShowLabel: boolean) {
        setShowLabel(newShowLabel);
    }

    function setMarkers(instrumentos: any[]): MarkerPoint[] {
        return instrumentos.map((instrumento, index) => {
            const uuid: string = instrumento.uuid;
            const position: [number, number] = [instrumento.latitude, instrumento.longitude];
            const title: string = instrumento.nome;
            const type: string = instrumento.tipo_instrumento;
            const ew: string = instrumento.utm_ew;
            const ns: string = instrumento.utm_ns;
            const elev: number = instrumento.elevacao;
            const update: string = instrumento.update_date;
            const icone: string = instrumento.icone;
            const route = `instrument/${index}`;
            const showMarker = true;
            return { uuid, position, title, type, ew, ns, elev, route, update, showMarker, icone };
        });
    }

    useEffect(() => {
        if (instrumentos !== undefined) {
            const newMarkerPoints = setMarkers(instrumentos);
            setMarkerPoints(newMarkerPoints);
        }
        else return;
    }, [instrumentos]);

    const handleShowMarkerChange = (id: string) => {
        const index = markerPoints.findIndex(marker => marker.uuid === id);
        if (index !== -1) {
            const updatedMarkerPoints = [...markerPoints];
            updatedMarkerPoints[index] = {
                ...updatedMarkerPoints[index],
                showMarker: !updatedMarkerPoints[index].showMarker
            };
            setMarkerPoints(updatedMarkerPoints);
        }
    };

    const handleDisableMarkersOfType = (markerType: string, enable: boolean) => {
        const updatedMarkerPoints = markerPoints.map(marker => {
            if (marker.type === markerType) {
                return {
                    ...marker,
                    showMarker: enable
                };
            }
            return marker;
        });
        setMarkerPoints(updatedMarkerPoints);
    };

    const toggleFullScreen = async () => {
        const newState = !isFullScreen;
        setIsFullScreen(newState);

        if (Capacitor.isNativePlatform()) {
            try {
                if (newState) {
                    await ScreenOrientation.lock({ orientation: 'landscape' });
                } else {
                    await ScreenOrientation.unlock();
                }
            } catch (e) {
                console.error("Erro ao gerenciar orientação da tela:", e);
            }
        }
    };

    return (
        <LayoutBase
            title={'Informações da Barragem'}
            overflowUser={smDown || isFullScreen ? 'auto' : 'hidden'}
            tollBar={
                <ToolsDamInformation
                    showSearch={false}
                />
            }
        >
            <>
                <Box
                    ref={vMenuRef}
                    sx={{ display: isFullScreen && smDown ? 'none' : 'block' }}
                >
                    <VMenu id={url.id} />
                    <Divider />
                </Box>

                {isLoading ?
                    <LinearProgress />
                    :
                    <Box
                        sx={{
                            height: isFullScreen ? '100vh' : `calc(100vh - ${vMenuHeight}px - 150px - ${theme.spacing(3)})`,
                            overflowY: isFullScreen ? 'hidden' : 'auto',
                            paddingBottom: theme.spacing(2),
                        }}
                    >
                        <Grid container>
                            <Grid item xs={12} padding={1}
                                sx={{ display: isFullScreen ? 'none' : 'block' }}
                            >
                                <Typography variant='h5' color={theme.palette.primary.main} >
                                    Mapa Geral da Estrutura
                                </Typography>
                                <Typography variant='body2' >
                                    Clique na legenda dos instrumentos para ativar/desativar no mapa
                                </Typography>
                            </Grid>
                            <Grid item container>
                                <Grid item xs={12} sm={isFullScreen ? 12 : 8}>
                                    <Box padding={1}>
                                        <ForwardedMapRender
                                            center={center ? center : [0, 0]}
                                            markerPoints={markerPoints}
                                            show={showLabel}
                                            type='map'
                                            ref={mapRef}
                                            isLocation={false}
                                            damName={damName}
                                            isFullScreen={isFullScreen}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={isFullScreen ? 12 : 4}
                                    sx={{ display: isFullScreen ? 'none' : 'block' }}
                                >
                                    <Box padding={2}>
                                        {/* <Typography color={theme.palette.primary.main} variant='h5' textAlign={'start'}>Opções</Typography> */}
                                        {/* <Divider /> */}
                                        <ButtonsDamInformation
                                            showLabel={showLabel}
                                            handleLabelChange={handleLabelChange}
                                            markerPoints={markerPoints}
                                            handleShowMarkerChange={handleShowMarkerChange}
                                            handleDisableMarkersOfType={handleDisableMarkersOfType}
                                            uuid={url.id}
                                            mapRef={mapRef}
                                            isFullScreen={isFullScreen}
                                            toggleFullScreen={toggleFullScreen}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={isFullScreen ? 12 : 12}
                                    sx={{ display: isFullScreen ? 'none' : 'block' }}
                                >
                                    <Box padding={2}>
                                        <Typography color={theme.palette.primary.main} variant='h5' textAlign={'start'}>Previsão Climática</Typography>
																				{/* <Typography variant='caption'>Considerar apenas os primeiros 5 dias *</Typography> */}
                                        <Divider /> 
																				{url.id !== undefined && (
                                        <TableForecast uuid_dam={url.id} />
																				)}
                                    </Box>
                                </Grid>
                                
                            </Grid>
                        </Grid>
                    </Box>
                }
            </>
        </LayoutBase>
    );
};